<template>
  <!-- {{ props }} -->
  <Bar
    v-if="props.data && props.options"
    id="my-chart-id"
    :options="props.options"
    :data="props.data"
  />
</template>
<script setup lang="ts">
import { ref } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Colors,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  TimeScale,
} from "chart.js";

ChartJS.register(
  Colors,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  TimeScale
);

ChartJS.defaults.font.family = "Inter";
ChartJS.defaults.font.size = 13;

const props = defineProps(["data", "options"]);

// console.log(props);

// const chartData = ref(props.data);

// const chartOptions = ref(props.options);
</script>
